import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import { Table } from './components/table';
import { useSelector } from 'react-redux';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import { useEffect, useState } from 'react';

import './styles.scss';

const dealerGroupTable = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [isSuccess, setIsSuccess] = useState(state.isSuccess ?? null);

    if (!state?.dealerGroups) {
        return (
            <Navigate
                to='/dashboard/systemadmin/dealer-group-maintenance'
                replace
            />
        );
    }

    let brand = 'vw';
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    if (currentDealers && dealerDataInfo) {
        const { dealer } = dealerDataInfo;
        brand = getBrandByDealerNumber(dealer.brand, dealer.dealerNumber);
    }

    useEffect(() => {
        if (state.isSuccess) {
            navigate('/dashboard/systemadmin/dealer-group-maintenance/search', {
                state: {
                    ...state,
                    isSuccess: false,
                },
                replace: true,
            });
        }
    }, []);

    return (
        <div className='dashboard-content-wrapper group-dealer'>
            <div className='dealer-group-maintenance-search dashboard-content-container'>
                {isSuccess && (
                    <div className={'u-mt-large'}>
                        <Notification
                            content={'Dealer successfully moved.'}
                            type={NotificationType.SUCCESS}
                            visibility={isSuccess}
                            setVisibility={setIsSuccess}
                        />{' '}
                    </div>
                )}
                <section className='o-content-section'>
                    <div className='page-title'>
                        <h5>Dealer Group Maintenance</h5>
                    </div>
                    <section className='c-form-section'>
                        <div className='c-form-section__content'>
                            <div className='o-fieldset__row u-mt-x-small u-mb-x-small'>
                                <div className='o-layout'>
                                    <div className='o-layout__item u-1/1 u-1/1@xs'>
                                        <p>
                                            View all dealers in this group
                                            below. Permissions apply to the
                                            entire group. Use Add to assign a
                                            dealer to this group, or Move to
                                            remove a dealer and assign it to a
                                            different group.
                                        </p>
                                    </div>
                                    <div className='o-layout__item u-1/1 u-1/1@xs'>
                                        <div className='aligned'>
                                            <p>
                                                <strong>
                                                    Results for{' '}
                                                    {state.dealerGroupSearch} |
                                                </strong>
                                                <strong>
                                                    {' '}
                                                    {
                                                        state.dealerGroups[0]
                                                            .dealerGroupName
                                                    }
                                                </strong>
                                            </p>
                                            <Link
                                                className='u-ml-large'
                                                to='/dashboard/systemadmin/dealer-group-maintenance'
                                            >
                                                {'< New search'}
                                            </Link>
                                        </div>
                                    </div>
                                    <hr className='u-ml-small u-mb--xsmall'></hr>
                                    <div className='o-layout__item u-1/3 u-1/3@xs'>
                                        <p>
                                            <strong>Dealer Groups</strong>
                                        </p>
                                        <Table items={state.dealerGroups} />
                                    </div>
                                    <div className='o-layout__item u-1/1 u-1/1@xs'>
                                        <div className='o-fieldset__row button-group'>
                                            <button
                                                className={`c-btn btn-primary ${brand}`}
                                                type='button'
                                                onClick={() => {
                                                    navigate(
                                                        '/dashboard/systemadmin/dealer-group-maintenance/add',
                                                        {
                                                            state: {
                                                                dealerId:
                                                                    state.dealerGroupSearch,
                                                                dealerGroupId:
                                                                    state
                                                                        .dealerGroups[0]
                                                                        .dealerGroupId,
                                                            },
                                                        },
                                                    );
                                                }}
                                            >
                                                <span className='c-btn__text'>
                                                    Add dealer
                                                </span>
                                            </button>
                                            <button
                                                className={`c-btn btn-secondary ${brand}`}
                                                type='button'
                                                onClick={() => {
                                                    navigate(
                                                        '/dashboard/systemadmin/dealer-group-maintenance/permissions',
                                                        {
                                                            state: {
                                                                dealers:
                                                                    state.dealerGroups,
                                                            },
                                                        },
                                                    );
                                                }}
                                            >
                                                <span className='c-btn__text'>
                                                    Manage group permissions
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div style={{ gridColumnStart: 2, marginTop: '40px' }}>
                        <FooterPrivacy />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default dealerGroupTable;
